import { Schema as S } from "effect";

const CalendarRefSchema = S.Struct({
  _id: S.String,
  calendarId: S.String,
});

const RequiredResourceSchema = S.Struct({
  _id: S.String,
  resourceType: S.String,
});

const ScheduleTypeSchema = S.Struct({
  _id: S.String,
  calendarRefs: S.Array(CalendarRefSchema),
  duration: S.Number,
  requiredResources: S.Array(RequiredResourceSchema),
  durationUnit: S.Union(
    [S.Literal("MINUTES"),
    S.Literal("HOURS"),
    S.Literal("DAYS"),
    S.Literal("WEEKS")],
  ),
  isPublic: S.Boolean,
  name: S.String,
  capacity: S.Number,
  numberOfSuggestedAppointments: S.Number,
  isPreconfigured: S.Boolean,
  color: S.String,
  type: S.String,
});

export const FindScheduleTypeResponseSchema = S.Array(ScheduleTypeSchema);

export type FindScheduleTypeResponse = S.Schema.Type<typeof FindScheduleTypeResponseSchema>;
